import core from '../../../js/core/core'
import * as types from '../mutation-types'
import EventBus from '@/vue/events/event-bus'
import moment from 'moment'

// initial state
const state = {
    arr_allBetEvent : {
      lgecapt: '',
      tacapt: '', 
      tacapt: '', 
    },
    sportAllBetLang: window._lang.sportAllBet,
    arr_csOddsEvent: null,
    arr_selectedBetTab: 8,
    refreshAllBet: false,
    isShowBottomRefresh: false,
}

// getters
const getters = {
    arr_allBetEvent: state => state.arr_allBetEvent,
    sportAllBetLang: state => state.sportAllBetLang,
    arr_csOddsEvent: state => state.arr_csOddsEvent,
    arr_selectedBetTab: state => state.arr_selectedBetTab,
    refreshAllBet: state => state.refreshAllBet,
    isShowBottomRefresh: state => state.isShowBottomRefresh,
}

// actions
const actions = {
  getSportAllBet(context, payload) {
    var token_val = payload.token
    // var eventDate = ''
    if(payload.event){
      // if(payload.event.dt){
      //   eventDate = new moment(payload.event.dt).locale('en').format("YYYY-MM-DD")
      // }
      // var filterDateIndex = _.indexOf(this.getters.arr_earlyParlayDateList, eventDate)
      // filterDateIndex = filterDateIndex != -1 ? filterDateIndex : 99
      // if(this.getters.arr_selectedTemplate.dt){
      //   filterDateIndex = this.getters.arr_selectedTemplate.dt
      // }
      // if(this.getters.int_marketToggle == 3 || (this.getters.int_marketToggle == 1 && this.getters.arr_selectedTemplate.subTemplateId != '2')){
      //   filterDateIndex = 0
      // }

      var bool_loading = true
      if(payload.loading == '1'){
          bool_loading = false
      }

      // var oddType = this.getters.account.oddsType
      
      // //if parlay have to pass 5
      // var plytypgrp = '1'
      // if(this.getters.arr_selectedTemplate.subTemplateId == '2'){
      //   oddType = oddType!='am'?'eu':oddType
      //   plytypgrp = '5'
      // }

      var sptid = (payload.event && payload.event.sptid) ? payload.event.sptid : payload.event.sprtid

      //livetv 
      var sportid = (payload && payload.sportId)?payload.sportId: 'N'+sptid;
      if(payload.sportId){
        if(payload.sportId.indexOf('G') >= 0) {
          sportid = 'N' + payload.event.sptid
        }
      }
      
      // var leagues = []
      // if(this.getters.arr_selectedTemplate.leagueid ) {
      //   leagues = [this.getters.arr_selectedTemplate.leagueid]  
      // }else{
      //   leagues = [this.getters.arr_selectedLeague.leagueid]
      // }

      // if(this.getters.arr_selectedTemplate.templateId == 6) {
      //   filterDateIndex = this.getters.arr_selectedTemplate.date
      //   filterDateIndex = filterDateIndex != -1 ? filterDateIndex : 99
      //   payload.event.eveid = this.getters.arr_selectedTemplate.eveid

      //   // sportid = this.getters.arr_selectedTemplate.sportId
      // }

      //if is show fav events
      // if(payload.showfavorite!=undefined){
      //   this.commit('SPORT_SHOW_FAV_EVENTS', payload.showfavorite)
      // } else {

      // }

      // var scheduled = 0
      // if(payload.event && (payload.event.rbstatus==1 || payload.event.event_rb==1)){
      //   scheduled = 3
      //   if(plytypgrp == '5') {
      //     plytypgrp = '1'
      //   }
      // } else {
      //   scheduled = this.getters.int_marketToggle

      //   //handle eventselection event date to see is today or early
      //   if(payload.event.dt){
      //     let eve_dt = payload.event.dt.split(" ");
      //     let a = _.indexOf(this.getters.arr_earlyParlayDateList, eve_dt[0])
      //     if(a==0 && scheduled != this.getters.market.tdyMarket.key){
      //       scheduled = this.getters.market.tdyMarket.key
      //     }
      //   }
      // }
      
      core.$ajax({
        method: 'post',
        url: _baseUrl + '/sport-allbet',
        data: {
          sprtid: sportid,
          schedule: this.getters.schedule,
          // schedule: scheduled, //payload.event && (payload.event.rbstatus==1 || payload.event.event_rb==1) ? 3 : this.getters.int_marketToggle
          // date: filterDateIndex,
          lang: window._langid,
          // spread: this.getters.account.spread,
          // odd: oddType,
          evntid: payload.event.eveid,
          enableLoading: bool_loading,
          plytypgrp: this.getters.playtype,
          timezone: this.getters.selected_timezone,
          // leagues: leagues,
          token: token_val,
        },
      }).done(((res)=> {
        if(res.allBet!=""){
          if(res.allBet.sp) {
            for (let eveid = 0; eveid < Object.keys(res.allBet.sp).length; eveid++) {
              _.assign(res.allBet.sp[Object.keys(res.allBet.sp)[eveid]] , { 'sptid': res.allBet.sptid })
            }
          }
          // var c = this.getters.arr_selectedLeague.c
          // this.dispatch('selectLeague',{
          //   leagueid : res.allBet.lgeid,
          //   lgecapt: res.allBet.lgecapt,
          //   c: c
          // })
          this.commit('ALLBETEVENT', res.allBet)
          this.commit('FULL_LOAD', false)
          this.commit('SELECTED_EVENT',payload.event)
          this.dispatch('sortAllBetEvents')
          if(payload.startTv && payload.startTv==1){
            EventBus.$emit('startTvDefault', res.allBet)
          }
          this.commit('LOADINGSCREEN', false)
          if(payload.callback) {
            return payload.callback(res)
          }
        }
        
      }).bind(this)).catch((errRes)=> {
        console.log(errRes)
      })
    }
  },
  sortAllBetEvents() {
    var sortedEvents = _.cloneDeep(this.getters.arr_allBetEvent)
    this.commit('ALLBETEVENT', _.cloneDeep(sortedEvents))

    if(this.getters.showFavEvents){
      var sortedFavRbEvents = _.cloneDeep(this.getters.favrbeventList)
      this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(sortedFavRbEvents))
    }
    if(this.getters.favouriteEvents || Object.keys(this.getters.favouriteEvents).length > 0){
      this.dispatch('allBetFavouriteEvents', {
        orderedEvents: sortedEvents,
        callback: ((res) => {
          this.commit('ALLBETEVENT', _.cloneDeep(res))
        })
      })

      if(state.sortedFavRbEventList){
        this.dispatch('allBetFavouriteEvents', {
          orderedEvents: state.sortedFavRbEventList,
          callback: ((res) => {
            this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(res))
          })
        })
      }
    }
    this.commit('LOADINGSCREEN', false)
  },
  getSportCorrectScore(context, payload) {
    var bool_loading = true;           
    if(payload && payload.loading == '1'){
        bool_loading = false
    }

    var bettype =this.getters.arr_selectedTemplate.sportId;
    var plytype = this.getters.arr_selectedTemplate.plytype;
    var schedule = this.getters.int_marketToggle;
    var date = '0';

    if(payload && payload.livetv){ //livetv date change
        bettype = (payload.sportId)?payload.sportId:"";
        plytype = (payload.playType)?payload.playType:"";
        schedule = (payload.schedule)?payload.schedule:"";
        date = payload.sDate;
    }else{
      if(this.getters.int_selectedParlayDate && schedule == '2'){  
        date = this.getters.int_selectedParlayDate    
      }
    }
    
    if(this.getters.arr_selectedTemplate.TemplateId == '21'){
      date = this.getters.int_selectedParlayDate    
      plytype = '5'
    }

    if(this.getters.arr_selectedTemplate.subTemplateId == '4'){  
      plytype = '2'
    }
    
    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,          
      odd: (this.getters.arr_selectedTemplate.subTemplateId == '4' && this.getters.account.oddsType!='am') ? this.getters.oddTypesList.EU.key: this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: 1,             
      date: date,
      plytypgrp : plytype,
      enableLoading: bool_loading,
      token: payload.token,
    }

    //if show league
    // if(this.getters.arr_selectedLeague){
    //   if(this.getters.arr_selectedLeague.leagueid ) {
    //     data.leagues = [this.getters.arr_selectedLeague.leagueid]  
    //   }
    // }
    // if(this.getters.arr_selectedTemplate){
      if(this.getters.arr_selectedTemplate.leagueid ) {
        data.leagues = [this.getters.arr_selectedTemplate.leagueid]  
      }else{
        if(this.getters.int_marketToggle == '3' && Object.keys(this.getters.arr_leagues).length == 0){ // for live
          var liveLgList = []
          _.forEach(this.getters.arr_liveLeague, function(res, key){
            liveLgList.push(res.id)
          })
    
          data.leagues = liveLgList
        }else {
          if(payload.state && payload.state != ''){
            var lgList = []
            var arrLgList = this.getters.arr_leagueList
              
            arrLgList = _.filter(this.getters.arr_leagueList, function(o){
              if(o.state == payload.state){
                return true
              }
            })

            _.forEach(arrLgList, function(d, k){
              lgList.push(d.id)
            })
            
            data.leagues = lgList
          }else{
            if(this.getters.arr_selectedLeague && Object.keys(this.getters.arr_selectedLeague).length > 0 && Object.keys(this.getters.arr_selectedLeagues).length == 0){ // for single
              data.leagues = [this.getters.arr_selectedLeague.leagueid]
            }else{
              if(this.getters.arr_selectedLeagues && Object.keys(this.getters.arr_selectedLeagues).length > 0){
                if(this.getters.arr_leagues && Object.keys(this.getters.arr_leagues).length > 0){ // select multiple league
                  var lgList = []
                  _.forEach(this.getters.arr_leagues, function(d, k){
                    lgList.push(d.leagueid)
                  })
                  
                  data.leagues = lgList
                }
              }else if(this.getters.arr_leagueList && Object.keys(this.getters.arr_leagueList).length > 0){ // for today matches
                var lgList = []
                var arrLgList = this.getters.arr_leagueList

                if(payload.state != ''){
                  
                  arrLgList = _.filter(this.getters.arr_leagueList, function(o){
                    if(o.state == payload.state){
                      return true
                    }
                  })
                }

                _.forEach(arrLgList, function(d, k){
                  lgList.push(d.id)
                })
                
                data.leagues = lgList
              }
            }
          }
        }
      }
    // }

    if(this.getters.selectedSort){
      data.sorttyp = this.getters.selectedSort
    }

    // var url = ''
    // if(this.getters.account.previewFlag == true){
    //   url = window._baseUrl + '/sport-odds-leagues-preview';
    // }else{
    //   url = window._baseUrl + '/sport-odds-leagues';
    // }

    var httpMethod = 'post'
    var url = ''
    if(this.getters.account.previewFlag == true){
      url = window._baseUrl + '/sport-odds-leagues-preview';
      if(this.getters.s_odd){
        url = window._baseUrl + '/sport-odds-preview';
      }
    }else{
      url = window._baseUrl + '/sport-odds-leagues';
      if(this.getters.s_odd){
        url = window._baseUrl + '/sport-odds';
      }
    }

    //cdn checking
    if(url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule
      httpMethod = 'get'
      data.gameMenuId = 0;
      delete data.leagues
      delete data.schedule
    }

    core.$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(((res)=> {
      var events = _.cloneDeep(res.events)
      // var earlyParlayDateList = res.earlyParlayDateList
      
      if(this.getters.arr_selectedLeague && res.events && Object.keys(res.events).length > 0){
        var c = this.getters.arr_selectedLeague.c
        this.dispatch('selectLeague',{
          leagueid : res.events[0][0].lgeid,
          lgecapt: res.events[0][0].lgecapt,
          c: c
        })
      }
      this.commit('CSODDSEVENT',events)
      this.commit('SUBLOAD', false)
      // this.commit('PARLAYDATELIST',earlyParlayDateList)
      this.dispatch('sortEvents')
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getSpecialCorrectScore(context, payload) {
    var bool_loading = true;           
    if(payload && payload.loading == '1'){
        bool_loading = false
    }

    var bettype =this.getters.arr_selectedTemplate.sportId;
    var plytype = this.getters.arr_selectedTemplate.plytype;
    var schedule = this.getters.int_marketToggle;
    var date = '0';

    if(payload && payload.livetv){ //livetv date change
        bettype = (payload.sportId)?payload.sportId:"";
        plytype = (payload.playType)?payload.playType:"";
        schedule = (payload.schedule)?payload.schedule:"";
        date = payload.sDate;
    }else{
      if(this.getters.int_selectedParlayDate && schedule == '2'){  
        date = this.getters.int_selectedParlayDate    
      }
    }
    
    if(this.getters.arr_selectedTemplate.TemplateId == '21'){
      date = this.getters.int_selectedParlayDate    
      plytype = '5'
    }

    if(this.getters.arr_selectedTemplate.subTemplateId == '4'){  
      plytype = '2'
    }
    
    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,          
      odd: (this.getters.arr_selectedTemplate.subTemplateId == '4' && this.getters.account.oddsType!='am') ? this.getters.oddTypesList.EU.key: this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: 1,             
      date: date,
      plytypgrp : plytype,
      enableLoading: bool_loading,
      token: payload.token,
    }

    //if show league
    // if(this.getters.arr_selectedLeague){
    //   if(this.getters.arr_selectedLeague.leagueid ) {
    //     data.leagues = [this.getters.arr_selectedLeague.leagueid]  
    //   }
    // }
    // if(this.getters.arr_selectedTemplate){
      if(this.getters.arr_selectedTemplate.leagueid ) {
        data.leagues = [this.getters.arr_selectedTemplate.leagueid]  
      }else{
        if(this.getters.int_marketToggle == '3' && Object.keys(this.getters.arr_leagues).length == 0){ // for live
          var liveLgList = []
          _.forEach(this.getters.arr_liveLeague, function(res, key){
            liveLgList.push(res.id)
          })
    
          data.leagues = liveLgList
        }else {
          if(this.getters.arr_selectedLeague && Object.keys(this.getters.arr_selectedLeague).length > 0){ // for single
            data.leagues = [this.getters.arr_selectedLeague.leagueid]
          }else{
            if(this.getters.arr_selectedLeagues && Object.keys(this.getters.arr_selectedLeagues).length > 0){
              if(this.getters.arr_leagues && Object.keys(this.getters.arr_leagues).length > 0){ // select multiple league
                var lgList = []
                _.forEach(this.getters.arr_leagues, function(d, k){
                  lgList.push(d.leagueid)
                })
                
                data.leagues = lgList
              }
            }else if(this.getters.arr_leagueList && Object.keys(this.getters.arr_leagueList).length > 0){ // for today matches
              var lgList = []
              _.forEach(this.getters.arr_leagueList, function(d, k){
                lgList.push(d.id)
              })
              
              data.leagues = lgList
            }
          }
        }
      }
    // }

    if(this.getters.selectedSort){
      data.sorttyp = this.getters.selectedSort
    }

    // var url = ''
    // if(this.getters.account.previewFlag == true){
    //   url = window._baseUrl + '/sport-odds-leagues-preview';
    // }else{
    //   url = window._baseUrl + '/sport-odds-leagues';
    // }

    var httpMethod = 'post'
    var url = window._baseUrl + '/sport-odds-leagues';
    if(this.getters.s_odd){
      url = window._baseUrl + '/sport-odds';
    }

    //cdn checking
    if(url == window._baseUrl + '/sport-odds') {
      url += '/' + data.schedule
      httpMethod = 'get'
      data.gameMenuId = 1; //euro
      delete data.leagues
      delete data.schedule
    }

    core.$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(((res)=> {
      var events = _.cloneDeep(res.events)
      // var earlyParlayDateList = res.earlyParlayDateList
      
      if(this.getters.arr_selectedLeague && res.events && Object.keys(res.events).length > 0){
        var c = this.getters.arr_selectedLeague.c
        this.dispatch('selectLeague',{
          leagueid : res.events[0][0].lgeid,
          lgecapt: res.events[0][0].lgecapt,
          c: c
        })
      }
      this.commit('CSODDSEVENT',events)
      this.commit('SUBLOAD', false)
      // this.commit('PARLAYDATELIST',earlyParlayDateList)
      this.dispatch('sortEvents')
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
}

// mutations
const mutations = {
    [types.ALLBETEVENT] (state, payload){
        state.arr_allBetEvent = payload
    },
    [types.CSODDSEVENT] (state, payload){
      state.arr_csOddsEvent = payload
    },
    [types.SELECTEDBETTYPE] (state, payload) {
      state.arr_selectedBetTab = payload
    },
    [types.REFRESHALLBET] (state, payload) {
      state.refreshAllBet = payload
    },
    SHOW_BOTTOMREFRESH (state, payload) {
      state.isShowBottomRefresh = payload
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/all-bet.js